<template>
    <div style="text-align: center">
        <router-link :to="`/employer/${this.item.employerId}/contract/${this.item.contractId}`" class="btn btn-success">
            Sign your contract
        </router-link>
    </div>
</template>

<script>

export default {
    props: ["item"]
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/SignContract.vue